import "core-js/modules/es.parse-int.js";
export var getStar = function getStar(star) {
  return [parseInt(star / 2), star % 2, 5 - parseInt(star / 2) - star % 2];
};